module.exports = __webpack_public_path__ + "img/record.5e375f26.png";